import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { bindActionCreators, Dispatch } from 'redux';
import { Stage } from 'react-konva';
import Game from './components/Game';
import NavBar from './components/UI/NavBar';
import global from './global';
import {
  undo,
  toggleModal,
  newGame,
  restartGame,
  showCardsOverflowMessage,
  setOrientation,
  increaseHintNumber,
} from './redux/actions';
import { history, IGameData, IModals, RecordState } from './redux/types';
import './App.css';
import Modal from './components/UI/Modal';
import WinModal from './components/UI/WinModal';
import Warning from './components/UI/Warning';
import detectOrientation, { Orientation } from './utils/detectOrientation';
import { Hints } from './functions/hints';
import RulesModal from './components/UI/RulesModal';
import Container from './components/UI/Container';

type Props = {
  history: history;
  actions: {
    undo: () => void;
    toggleModal: (name: string) => void;
    newGame: () => void;
    restartGame: () => void;
    showCardsOverflowMessage: (visible: boolean, maxCards: number, needCards: number) => void;
    setOrientation: (orientation: Orientation, contentWidth: number) => void;
    increaseHintNumber: () => void;
  };
  modals: IModals;
  cardsOverflowMessage: {
    isVisible: boolean;
    maxCards: number;
    needCards: number;
  };
  gameData: IGameData;
  orientation: Orientation | void;
  size: number;
  hintNumber: number;
  hints: Hints;
};

const theme = createMuiTheme({
  zIndex: {
    drawer: 1200,
    modal: 1300,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    secondary: {
      main: '#ffcd38',
    },
  },
});

class App extends Component<Props> {
  Stage: any;
  holdClick: boolean = false;

  getStage = () => {
    return this.Stage;
  };

  componentDidMount() {
    const { actions } = this.props;
    global.getStage = () => this.Stage;

    global.ee.on('undo', () => {
      actions.undo();
    });

    global.ee.on('new_game', () => {
      actions.toggleModal('newGame');
    });

    global.ee.on('restart', () => {
      actions.toggleModal('restart');
    });
  }

  onRestart = () => {
    const { actions } = this.props;
    global.sounds.shuffle();
    actions.restartGame();
  };

  onNewGame = () => {
    const { actions } = this.props;
    global.sounds.shuffle();
    actions.newGame();
  };

  render() {
    const { modals, actions, cardsOverflowMessage, gameData, size } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <Container
          size={size}
          gameRef={stage => (this.Stage = stage)}
          onResize={(orientation, contentWidth) => {
            actions.setOrientation(orientation, contentWidth);
          }}
          nav={<NavBar getStage={this.getStage} />}
        />

        <Modal
          open={modals.restart.isVisible}
          onClose={() => actions.toggleModal('restart')}
          onAgree={this.onRestart}
          onDisagree={() => actions.toggleModal('restart')}
          title="Вы уверены, что хотите начать расклад заново?"
        />

        <Modal
          open={modals.newGame.isVisible}
          onClose={() => actions.toggleModal('newGame')}
          onAgree={this.onNewGame}
          onDisagree={() => actions.toggleModal('newGame')}
          title="Вы уверены, что хотите начать новую игру?"
        />

        <RulesModal open={modals.rules.isVisible} onClose={() => actions.toggleModal('rules')} />

        <WinModal onRestart={this.onRestart} onNewGame={this.onNewGame} gameData={gameData} />

        <Warning
          cardsOverflowMessage={cardsOverflowMessage}
          onClose={() =>
            actions.showCardsOverflowMessage(false, cardsOverflowMessage.needCards, cardsOverflowMessage.maxCards)
          }
        />
      </ThemeProvider>
    );
  }
}

function mapStateToProps(state: RecordState) {
  return {
    history: state.get('history'),
    modals: state.get('modals'),
    cardsOverflowMessage: state.get('cardsOverflowMessage'),
    gameData: state.get('gameData'),
    orientation: state.get('orientation'),
    size: state.get('size'),
    hintNumber: state.get('hintNumber'),
    hints: state.get('hints'),
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actions: {
      undo: bindActionCreators(undo, dispatch),
      toggleModal: bindActionCreators(toggleModal, dispatch),
      newGame: bindActionCreators(newGame, dispatch),
      restartGame: bindActionCreators(restartGame, dispatch),
      showCardsOverflowMessage: bindActionCreators(showCardsOverflowMessage, dispatch),
      setOrientation: bindActionCreators(setOrientation, dispatch),
      increaseHintNumber: bindActionCreators(increaseHintNumber, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
